import classNames from 'classnames';
import * as React from 'react';

import { IAgentReviewsSchema } from 'shared/types/api-models/offer-card/v1/get-offer-data';

import { Avatar } from '../../common/components/avatar';
import { LinkWrapper } from '../../common/components/link_wrapper';
import { Tag } from '../../common/components/tag';
import { AgentStats } from '../agent_stats';
import * as styles from './agentPreview.css';
import { ArmorIcon } from './armorIcon';

export interface IAgentPreviewProps {
  link?: string;
  name?: string | null;
  avatar?: string;
  agentReviews: IAgentReviewsSchema | null;
  showProTag: boolean;
  showIsPrivateBroker: boolean;
  showPhotoBorder: boolean;
  makeWhiteColor: boolean;
  proTagClassName?: string;

  onClick?(): void;
}

export function AgentPreview(props: IAgentPreviewProps) {
  const {
    avatar = '',
    link,
    name,
    agentReviews,
    showProTag,
    showIsPrivateBroker,
    showPhotoBorder,
    makeWhiteColor,
    proTagClassName,
    onClick,
  } = props;

  return (
    <div className={classNames(styles['agent-preview'], makeWhiteColor && styles['white-color'])}>
      <LinkWrapper
        href={link}
        target="_blank"
        notRemoveWrapper
        onClick={onClick}
        className={classNames(styles['link'], showPhotoBorder && styles['photo-border'])}
      >
        <Avatar isRoundness url={avatar} className={styles['avatar']} />
      </LinkWrapper>
      <div className={styles['content']}>
        <div className={styles['content_top']}>
          {name && (
            <LinkWrapper href={link} target="_blank" notRemoveWrapper onClick={onClick} className={styles['name']}>
              {name}
            </LinkWrapper>
          )}
          {showProTag && (
            <div className={styles['pro_tag_container']}>
              <ArmorIcon />
              <Tag className={classNames(styles['tag'], proTagClassName)} title="Профессиональный пользователь">
                Pro
              </Tag>
            </div>
          )}
        </div>

        <div className={styles['bottom_info']}>
          {showIsPrivateBroker && <span className={styles['company_name']}>Частный маклер</span>}
          {agentReviews && <AgentStats agentReviews={agentReviews} link={link} uniqueKey="agent-preview" />}
        </div>
      </div>
    </div>
  );
}
